import * as React from "react";
import { SaveButton, Toolbar } from "react-admin";

const InactiveDeleteOptionEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export default InactiveDeleteOptionEditToolbar;
